import { updatesData } from '@/mocks/homeData';

const tagStyleMap: Record<string, string> = {
  '热播': 'bg-primary-100 text-primary-700',
  '新剧': 'bg-accent-100 text-accent-700',
  '公告': 'bg-secondary-100 text-secondary-700',
  '专题': 'bg-accent-100 text-accent-700',
  '更新': 'bg-secondary-100 text-secondary-700',
  '上新': 'bg-primary-100 text-primary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            最新动态
          </h2>
          <div className="w-12 h-1 bg-primary-500 rounded-full mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            麻花视频最新资讯与内容播报
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updatesData.map((item, i) => (
            <div key={i} className="relative flex gap-4 pb-6 last:pb-0">
              <div className="flex flex-col items-center shrink-0">
                <div className="w-3 h-3 rounded-full bg-primary-500 mt-1.5"></div>
                {i < updatesData.length - 1 && (
                  <div className="w-px flex-1 bg-background-200 mt-1.5"></div>
                )}
              </div>
              <div className="flex-1 min-w-0 pb-2">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${tagStyleMap[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}